var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Menu / Hub") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu-/-Hub",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layout-module"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0.75,
    y: 0.747,
    width: 4.5,
    height: 4.5,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 9.75,
    y: 0.747,
    width: 4.5,
    height: 4.5,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 18.75,
    y: 0.747,
    width: 4.5,
    height: 4.5,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0.75,
    y: 9.747,
    width: 4.5,
    height: 4.5,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 9.75,
    y: 9.747,
    width: 4.5,
    height: 4.5,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 18.75,
    y: 9.747,
    width: 4.5,
    height: 4.5,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0.75,
    y: 18.747,
    width: 4.5,
    height: 4.5,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 9.75,
    y: 18.747,
    width: 4.5,
    height: 4.5,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 18.75,
    y: 18.747,
    width: 4.5,
    height: 4.5,
    rx: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHub);
export default __webpack_public_path__ + "static/media/hub.c1f03dd74aa8cf12303db2d4025bddad.svg";
export { ForwardRef as ReactComponent };